import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";

import { AuthenticationCoreModule } from "@guest-web/core";
import { TrpButtonComponent } from "@triparound/trp-components/button";
import { TrpDialogDirective, TrpToastUtil } from "@triparound/trp-components/feedback";
import {
	TrpCheckboxComponent,
	TrpInputComponent,
	TrpPasswordInputComponent,
} from "@triparound/trp-components/inputs";
import { TrpImageComponent, TrpPoweredComponent } from "@triparound/trp-components/media";

import { AuthenticationFacadeService } from "./authentication-facade.service";
import { AuthenticationGuard } from "./authentication.guard";
import { LoggedInAuthenticationGuard } from "./logged-in-auth.guard";
import { LoginComponent } from "./login.component";

@NgModule({
	imports: [
		CommonModule,
		FormsModule,
		ReactiveFormsModule,
		AuthenticationCoreModule,
		TrpImageComponent,
		TrpPoweredComponent,
		TrpInputComponent,
		TrpCheckboxComponent,
		TrpButtonComponent,
		TrpPasswordInputComponent,
		TrpDialogDirective,
		LoginComponent,
	],
	providers: [
		AuthenticationFacadeService,
		AuthenticationGuard,
		LoggedInAuthenticationGuard,
		TrpToastUtil,
	],
})
export class AuthenticationModule {}
